import request from '@/utils/request'
import constant from '@/api/constant'


export function findToken () { // 获取token
  return request({
    url: '/api/zauser/findtoken',
    method: 'post',
    params: {
      appCode: sessionStorage.getItem('theAppCode'),
      platform: constant.TOKENPARAMS
    }
  })
}

export function loginByUsername (username, password) { // 根据登录名登录
  return request({
    url: '/zauser/loginZaUser',
    method: 'post',
    params: {
      loginName: username,
      password: password,
      appCode: constant.COMMON_APPCODE
    }
  })
}

export function loginByMobile (mobile, code) { // 根据手机号登录
  return request({
    url: '/zauser/loginByMobile',
    method: 'post',
    params: {
      mobile: mobile,
      smscode: code,
      appCode: constant.COMMON_APPCODE
    }
  })
}

export function getUserInfo () { // 根据token获取用户信息
  return request({
    url: '/zauser/findZaUserByToken',
    method: 'post'
  })
}

export function logout () { // 登出
  return request({
    url: '/zauser/loginZaUserOut',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js